import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import EricAnalyst from './EricAnalyst.js';

class Eric extends Component {
  render() {
    return (
      <div className="content-wrapper">
        <div className="content-body">
          <Switch>
            <Route exact path={this.props.match.url} component={EricAnalyst} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Eric;
